const StepButtonArrowLong = () => (
    <svg
        width='17'
        height='9'
        viewBox='0 0 17 9'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <line
            y1='-0.5'
            x2='12'
            y2='-0.5'
            transform='matrix(-1 8.74228e-08 8.74228e-08 1 17 5)'
            stroke='#23B3E5'
        />
        <path
            d='M0.75 4.93301C0.416666 4.74056 0.416667 4.25944 0.75 4.06699L6 1.0359C6.33333 0.843449 6.75 1.08401 6.75 1.46891L6.75 7.53109C6.75 7.91599 6.33333 8.15655 6 7.9641L0.75 4.93301Z'
            fill='#23B3E5'
        />
    </svg>
);

export default StepButtonArrowLong;
